import moment from 'moment';

interface IMonthDateRange {
  startDate: string;
  endDate: string;
}

/**
 * Returns start and end dates of current month with specific time components
 * @returns {IMonthDateRange} Object containing start date (T00:00:00.000Z) and end date (T23:59:59.999Z)
 */
export const getCurrentMonthDateRange = (month: Date | string): IMonthDateRange => {
  const startDate = moment(month).startOf('month').utc().toISOString();
  const endDate = moment(month).endOf('month').utc().toISOString();
  return {
    startDate,
    endDate
  };
};